import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/store';
import ButtonActionStatus from '@pages/OrganizedSales/CreateOrders/common/ButtonActionStatus';
import { CheckOutlined, LoadingOutlined } from '@ant-design/icons';
import { Form, Input, message } from 'antd';
import AuthServiceApi from 'apis/api/Auth';
import { updateAccountUser } from '@slice/user.slice';

type TypeUpdateUserInfo = {
  DisplayName: any;
  NumberPhone: any;
  Email: any;
  Extension: any;
};

const initalForm: TypeUpdateUserInfo = {
  DisplayName: null,
  NumberPhone: null,
  Email: null,
  Extension: null
};

interface IUpdateUserInfoForm {
  isClickOut?: any;
}

export default function UpdateUserInfoForm(props: IUpdateUserInfoForm) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // State

  const account = useSelector((state: RootState) => state.user.account);

  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [form] = Form.useForm();

  const handleFormSubmit = async (evt: TypeUpdateUserInfo) => {
    const dataBody = {
      displayName: evt.DisplayName || account.displayName,
      email: evt.Email || account.email,
      extension: evt.Extension || account.extension,
      phoneNumber: evt.NumberPhone || account.phone
    };
    try {
      setConfirmLoading(true);
      await AuthServiceApi.ChangeCurrentInfoAcc(dataBody).then(res => {
        if (!res.data.error) {
          message.success(t('Header.UserAcount.Success.UpdateInfoSuccess'));
          // gọi update thông tin acc
          dispatch(updateAccountUser(dataBody));
        } else {
          message.error(t('Header.UserAcount.Error.UpdateInfoError'));
        }
        setConfirmLoading(false);
      });
    } catch (error) {
      setConfirmLoading(false);
      console.log(error);
      message.error(t('Header.UserAcount.Error.UpdateInfoError'));
    }
  };

  useEffect(() => {
    if (account) {
      form.setFieldsValue({
        DisplayName: account.displayName,
        NumberPhone: account.phone,
        Email: account.email,
        Extension: account.extension
      });
    }
  }, [account]);

  return (
    <>
      <div className="my-4">
        <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
          <Form.Item
            label={t('Administrator.AccountManager.DisplayName')}
            name={'DisplayName'}
            style={{ marginBottom: 2 }}
          >
            <Input style={{ width: '100%' }} placeholder={t('Input.placeholder')} />
          </Form.Item>
          <Form.Item
            className="flex flex-col"
            label={t('Administrator.AccountManager.NumberPhone')}
            name={'NumberPhone'}
            style={{ marginBottom: 2 }}
          >
            <Input style={{ width: '100%' }} placeholder={t('Input.placeholder')} />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: 2 }}
            className="flex flex-col"
            label={t('Administrator.AccountManager.Email')}
            name={'Email'}
          >
            <Input style={{ width: '100%' }} placeholder={t('Input.placeholder')} />
          </Form.Item>
          <Form.Item className="flex flex-col" label={t('Administrator.AccountManager.Extension')} name={'Extension'}>
            <Input style={{ width: '100%' }} placeholder={t('Administrator.AccountManager.plHolderIP')} />
          </Form.Item>
        </Form>
        <ButtonActionStatus
          showButton={true}
          htmlType="submit"
          onClick={form.submit}
          icon={
            <span className="mr-2">
              {confirmLoading ? (
                <LoadingOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />
              ) : (
                <CheckOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />
              )}
            </span>
          }
          text={t('Button.Save')}
          type="primary"
        />
      </div>
    </>
  );
}
